// extracted by mini-css-extract-plugin
module.exports = {"Adreses":"allShopsMap_Adreses__ila2_","AdresesBaltex":"allShopsMap_AdresesBaltex__JqJkL","Adr":"allShopsMap_Adr__ZSUCD","Map":"allShopsMap_Map__rWYB8"};